import { CfMinimalStripContentProps } from "./schema";
import MinimalStripContent from "..";
import React from "react";

const convertCfMinimalStripContentProps = (
  props: CfMinimalStripContentProps,
) => {
  return props;
};

const CfMinimalStripContent = (props: CfMinimalStripContentProps) => (
  <MinimalStripContent {...convertCfMinimalStripContentProps(props)} />
);

export default CfMinimalStripContent;
